module.exports = __webpack_public_path__ + "img/facilities-icon-6.5333da78.svg";